module.exports = __webpack_public_path__ + "static/media/W05F0007N0000.acee9661.svg";